import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";

import styles from "assets/jss/material-kit-react/views/learningPage.js";
import FullWidthImage from "./Sections/FullWidthImage";
import Dashboard from "./Sections/Dashboard";
import swal from 'sweetalert'

import Menu from "./Sections/Menu";
import {
  useParams
} from "react-router-dom";
import Payment from "./Sections/Payment";
import ContactUs from "./Sections/ContactUs";

const useStyles = makeStyles(styles);

export default function LearningPage(props) {

  const classes = useStyles();
  const { ...rest } = props;
  let { id } = useParams();
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
  var token = localStorage.getItem('token');
  var level = localStorage.getItem('level');
  if(!token||!level||level<3){
    localStorage.clear();
    window.location = "/SignIn";
  }
  return (
    <div>
      <Header
        color="transparent"
        brand="Material Kit React"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 30,
          color: "white"
        }}
        {...rest}
      />
      <Parallax verySmall filter image={require("assets/img/bg7.jpg")} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div>
          <FullWidthImage image={"https://sharifcamp.ir/assets/images/adminHeader.jpg"} />
          <Menu active={0} />

      {(() => {
        if (!id || id == "Dashboard") {
          return (
           <Dashboard></Dashboard>
          )
        }else if (id == "Payment") {
          return (
           <Payment></Payment>
          )
        }
        else if (id == "ContactUs") {
          return (
           <ContactUs></ContactUs>
          )
        }
      })()}
        </div>
      </div>
      <Footer />
    </div>
  )
}
